export default "__VITE_ASSET__RnKmS8VU__"